<style scoped lang="scss">
.container{
  width: 1400px;
}
.con{
  .context{
    font-size: 12px;
  }
}
.context{
  p{
    margin-bottom: 5px;
    line-height: 2;
    text-indent: 2em;
  }
  p:last-child{
    margin-bottom: 0;
  }
}
.cons{
  display: none;
}
.left{
  float: left;
  overflow: auto;
  width: 100%;
}
.right{
  width: 53%;
  margin-left: 2%;
  float: right;
}
  .c-title{
    text-align: left;
   padding: 0 0 20px 0!important;
  }
  .contents{
    display: flex;
    display: -webkit-flex;
    display: -o-flex;
    display: -moz-flex;
    height: 360px;
    overflow-y: auto;
    display: -ms-flex;
    align-items: stretch;
  }
</style>
<style scoped>
@media screen and (max-width: 640px){
  .container{
    width: 100% !important;
    font-size: 12px!important;
    text-align: justify;
    padding-left: 15px;
    padding-right: 15px;
  }
  .c-title{
    padding: 20px 0 20px!important;
    font-size: 18px!important;
  }

}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .cons{
    display: block!important;
  }
  .con{
    display: none!important;
  }
  .right{
    width: 100% !important;
  }
}
@media screen and (max-width: 641px){
  .breads{
    display: none!important;
  }
}
</style>
<template>
  <div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;margin-top: 20px;">
      <Bread />
    </div>
    <div class="container con" style="overflow: auto">
      <div class="contents">
        <div class="left">
          <div class="context">
            <!-- <p>北京擎科生物科技股份有限公司（Beijing Tsingke Biotech Co., Ltd.）是一家自主全产业链的基因合成平台型企业，业务范围涵盖合成基因组学产品及服务、生命科学原料及设备、生物制造CXO三大方向。公司肩负推动“生物科技让世界更美好”的使命，秉承“品质、创新、奋斗、共赢”的价值观，始终将行业需求作为公司的导向，为客户提供基因合成、修饰合成、化学试剂、分子试剂、仪器设备和多种项目服务。</p>
            <p>企业总部位于北京，运营实体和实验室遍布全国，总运营面积超 70,000 m²。作为基因合成领域的佼佼者，经过多年的数据和经验积累，以及合成生物学研发和应用平台搭建，擎科生物形成了完整的基因合成产业链和完善的服务体系，业务覆盖全国并延伸至美国、德国等多个海外国家和地区，为全球超过20万用户提供服务与产品。</p>
            <p>作为国家高新技术企业、北京市知识产权示范单位，擎科生物注重自主研发的同时，通过多领域专业人才的引进，不断发展和完善核心技术创新研发体系。参与多项国家及省部级科技研发项目，同时参与制定了国家及行业相关标准。自公司成立以来，先后与浙江工业大学、天津工业生物技术研究所等多家高校和科研院所进行战略合作，并与知名院士团队共建生物技术联合创新中心，进行校企合作、培育行业人才，实现产学研一体化，引领合成生物学的创新发展。</p>
            <p>擎科生物致力于为从事生命科学研究的科研人员及企事业单位提供高质量、本地化的生物技术服务和产品，公司已通过CNAS质量体系认证，拥有符合生物医药诊断标准的10万级洁净生产车间和自动化生产设备，以及超过12,000 m²的创新研发中心。截至2023年1月，公司现有员工1,200余名。擎科现有授权及在申专利共194项，其中发明专利91项，基因合成系列设备专利约90项。使用擎科生物服务和产品发表的文章数量累计超过6,818篇，影响因子累计达到29,393.2037。
              <span :style="{color: '#999'}">医疗器械类产品生产由旗下子公司湖北擎科生物科技有限公司生产。</span>
            </p> -->
            <p>北京擎科生物科技股份有限公司（Beijing Tsingke Biotech Co., Ltd.）是一家自主全产业链的基因合成平台型企业，业务范围涵盖合成基因组学产品及服务、生命科学原料及设备、生物制造CXO三大方向。</p>
            <p>公司肩负推动“生物科技·让世界更美好”的使命，秉承“品质、创新、奋斗、共赢”的价值观，始终将行业需求作为公司的导向。作为“基因工厂”的提出者和践行者，通过搭建基因合成要素中原料、设备的生产平台、基因智能分子拆分及组装技术平台、智能AI算法平台螺旋桨系统（TSINGKE HELIXTECH），形成了合成要素自主的全产业链生产平台，为客户提供基因合成、修饰合成、抗体蛋白、基因调控、基因检测、化学试剂、分子试剂、仪器设备和多种技术服务等。</p>
            <p>作为国家高新技术企业、国家级博士后科研工作站、北京市企业技术中心、北京市知识产权示范单位，擎科生物注重自主研发的同时，通过多领域专业人才的引进，不断发展和完善核心技术创新研发体系。参与多项国家及省部级科技研发项目，同时参与制定了行业及团体相关标准。企业总部位于北京，运营实体和实验室遍布全国，总运营面积超70,000 m²。致力于为全球从事生命科学研究的科研人员及企事业单位提供高质量的生物技术服务和产品，业务覆盖全国并延伸至美洲、欧洲等海外地区，拥有快速响应客户需求的能力，为全球近20万用户提供服务与产品。</p>
          </div>
        </div>
        <!-- <div class="right">
          <video src="@/assets/video/0114擎科生物-Final.mp4"  controls="controls" width="100%" style="margin-top: 5px;"></video>
        </div> -->
      </div>
    </div>
    <div class="container cons" style="overflow: auto">
          <div class="context">
            <!-- <p>北京擎科生物科技股份有限公司（Beijing Tsingke Biotech Co., Ltd.）是一家自主全产业链的基因合成平台型企业，业务范围涵盖合成基因组学产品及服务、生命科学原料及设备、生物制造CXO三大方向。公司肩负推动“生物科技让世界更美好”的使命，秉承“品质、创新、奋斗、共赢”的价值观，始终将行业需求作为公司的导向，为客户提供基因合成、修饰合成、化学试剂、分子试剂、仪器设备和多种项目服务。</p>
            <p>企业总部位于北京，运营实体和实验室遍布全国，总运营面积超 70,000 m²。作为基因合成领域的佼佼者，经过多年的数据和经验积累，以及合成生物学研发和应用平台搭建，擎科生物形成了完整的基因合成产业链和完善的服务体系，业务覆盖全国并延伸至美国、德国等多个海外国家和地区，为全球超过20万用户提供服务与产品。</p>
            <p>作为国家高新技术企业、北京市知识产权示范单位，擎科生物注重自主研发的同时，通过多领域专业人才的引进，不断发展和完善核心技术创新研发体系。参与多项国家及省部级科技研发项目，同时参与制定了国家及行业相关标准。自公司成立以来，先后与浙江工业大学、天津工业生物技术研究所等多家高校和科研院所进行战略合作，并与知名院士团队共建生物技术联合创新中心，进行校企合作、培育行业人才，实现产学研一体化，引领合成生物学的创新发展。</p>
            <p>擎科生物致力于为从事生命科学研究的科研人员及企事业单位提供高质量、本地化的生物技术服务和产品，公司已通过CNAS质量体系认证，拥有符合生物医药诊断标准的10万级洁净生产车间和自动化生产设备，以及超过12,000 m²的创新研发中心。截至2023年1月，公司现有员工1,200余名。擎科现有授权及在申专利共194项，其中发明专利91项，基因合成系列设备专利约90项。使用擎科生物服务和产品发表的文章数量累计超过6,818篇，影响因子累计达到29,393.2037。
              <span :style="{color: '#999'}">医疗器械类产品生产由旗下子公司湖北擎科生物科技有限公司生产。</span>
            </p> -->
            <p>北京擎科生物科技股份有限公司（Beijing Tsingke Biotech Co., Ltd.）是一家自主全产业链的基因合成平台型企业，业务范围涵盖合成基因组学产品及服务、生命科学原料及设备、生物制造CXO三大方向。</p>
            <p>公司肩负推动“生物科技·让世界更美好”的使命，秉承“品质、创新、奋斗、共赢”的价值观，始终将行业需求作为公司的导向。作为“基因工厂”的提出者和践行者，通过搭建基因合成要素中原料、设备的生产平台、基因智能分子拆分及组装技术平台、智能AI算法平台螺旋桨系统（TSINGKE HELIXTECH），形成了合成要素自主的全产业链生产平台，为客户提供基因合成、修饰合成、抗体蛋白、基因调控、基因检测、化学试剂、分子试剂、仪器设备和多种技术服务等。</p>
            <p>作为国家高新技术企业、国家级博士后科研工作站、北京市企业技术中心、北京市知识产权示范单位，擎科生物注重自主研发的同时，通过多领域专业人才的引进，不断发展和完善核心技术创新研发体系。参与多项国家及省部级科技研发项目，同时参与制定了行业及团体相关标准。企业总部位于北京，运营实体和实验室遍布全国，总运营面积超70,000 m²。致力于为全球从事生命科学研究的科研人员及企事业单位提供高质量的生物技术服务和产品，业务覆盖全国并延伸至美洲、欧洲等海外地区，拥有快速响应客户需求的能力，为全球近20万用户提供服务与产品。</p>
          </div>
        <!-- <div class="right">
          <video src="@/assets/video/0114擎科生物-Final.mp4"  controls="controls" width="100%" style="margin-top: 5px;"></video>
        </div> -->
    </div>


  </div>
</template>
<script>
import Bread from "@/components/bread"
export default {
  components: {
    Bread,
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/summary/about.vue